import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LanguageService } from '../../services/language.service';
import { Subscription } from "rxjs";
import { ZendeskArticleSearchResult, ZendeskSearchResult } from "../../models/zendesk-search-result";
import { ZendeskService } from "../../services/zendesk.service";
import { NgcCookieConsentService } from "ngx-cookieconsent";
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ZendeskAttachment, ZendeskAttachmentsResult } from "../../models/zendesk-attachments-result";
import { MatomoTracker } from "ngx-matomo";

declare let ga: Function;

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css']
})
export class ArticleComponent implements OnInit, OnDestroy {

  id: string;

  article: ZendeskSearchResult;

  safeHtml: SafeHtml;

  sub: Subscription;

  zendeskError = false;

  attachments: ZendeskAttachment[] = [];

  constructor(
    private route: ActivatedRoute,
    private zendeskSvc: ZendeskService,
    public language: LanguageService,
    private ccService: NgcCookieConsentService,
    private sanitizer: DomSanitizer,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Article');

    this.sub = this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.getArticle();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getArticle() {
    this.zendeskSvc.getArticle(this.id).subscribe(page => {
      this.zendeskError = false;
      if ((page as ZendeskArticleSearchResult).article !== undefined) {
        this.article = (page as ZendeskArticleSearchResult).article;
        this.article.body = this.article.body.replace(new RegExp('<a href="#', 'g'), `<a href="/${this.language.getLang()}/articles/${this.id}#`);
        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.article.body);
        if (environment.production && this.ccService.hasConsented()) {
          ga('send', 'event', 'ZenDesk Article', 'read', this.article.title, this.article.id);
        }
      }

      this.zendeskSvc.getArticleAttachments(this.id).subscribe(results => {
        console.log(results);
        this.attachments = (results as ZendeskAttachmentsResult).article_attachments;
      }, _ => {
      });
    }, _ => {
      this.zendeskError = true;
    });
  }

  formatSize(size): string {
    if (size < 1000) {
      return size + ' B';
    }
    size /= 1024;
    if (size < 1000) {
      return Math.trunc(size) + ' KB';
    }
    size /= 1024;
    if (size < 1000) {
      return Math.trunc(size) + ' MB';
    }
    size /= 1024;
    return Math.trunc(size) + ' GB';
  }
}
